import { Outlet, redirect, useLocation } from "react-router";
import { useState, useContext, useEffect, useCallback } from "react";
import { MainNavigation } from "../modules/home/components/MainNavigation";
import { RaceBy } from "@uiball/loaders";
import { Transition } from "@headlessui/react";
import { Store } from "../context/store";
import { APICompletion, apiHandler } from "../service/apiHelper";
import { Company } from "../modules/home/models/Company";
import { ErrorPage } from "../modules/error/ErrorPage";

export const RootLayout = () => {
  const location = useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const [apiResponse, setApiResponse] = useState<APICompletion>();
  const store = useContext(Store);
  const headers = {
    "x-api-key": store.apiKey,
  };

  const getCompanyInformation = useCallback(() => {
    getCompany();
  }, []);

  const getCompany = async () => {
    const api = await apiHandler({
      url: `${store.baseUrl}/${store.code}`,
      method: "GET",
      headers: headers,
    });

    if (api.success) {
      let link = document.querySelector(
        "link[rel~='icon']"
      ) as HTMLAnchorElement;
      link.href = api.data.favIconUrl;
      store.setCompany(api.data);
      setApiResponse(api);
    } else {
      setApiResponse(api);
    }
    setIsLoading(false);
  };

  useEffect(() => {
    document.title = "Jobs HRFlex";

    getCompanyInformation();
  }, []);
  return (
    <>
      <div className="bg-white overscroll-contain">
        {isLoading ? (
          <div className="grid h-screen place-items-center">
            <RaceBy size={120} lineWeight={5} speed={1.4} color="#3F52E3" />
          </div>
        ) : apiResponse?.success === false ? (
          <ErrorPage />
        ) : (
          <Transition
            show={!isLoading}
            appear={true}
            as="div"
            enter="transition ease-out duration-300"
            enterFrom="transform opacity-0 scale-95"
            enterTo="transform opacity-100 scale-100"
            leave="transition ease-in duration-75"
            leaveFrom="transform opacity-100 scale-100"
            leaveTo="transform opacity-0 scale-95"
          >
            <MainNavigation />
            <Outlet />
          </Transition>
        )}
      </div>
    </>
  );
};
